<style scoped>
.ipt-sty {
  width: 70% !important;
}
.title-box {
  display: flex;
  align-items: center;
  padding-left: 50px;
}
.title-box-name{
  width: 110px;
  flex-shrink: 0;
  text-align: right;
}
.title-box-name span {
  color: red;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="20">
        <el-col :span="9"
          ><div class="search-area-div">调研对象：</div>
          <el-input v-model="page.paramName" class="ipt-sty" placeholder="请输入名称" :clearable="true"></el-input
        ></el-col>
        <el-col :span="7">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">新增调研对象</el-button>
      <el-button size="medium" type="danger" @click="deleteData(1, '')">批量删除</el-button>
    </div>
    <div class="back-color-fff" style="padding: 16px">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column prop="paramValue" label="客户类型编号" header-align="center" align="left"> </el-table-column>
        <el-table-column prop="paramName" label="客户类型" header-align="center" align="left"> </el-table-column>
        <el-table-column prop="createUserName" label="操作人" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="deleteData(2, scope.row)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <div class="title-box">
        <div class="title-box-name"><span>*</span>客户类型编号：</div>
        <el-input class="w60f" v-model="ruleForm.paramValue" type="number"  placeholder="请输入"></el-input>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span>*</span>客户类型名称：</div>
        <el-input class="w60f" v-model="ruleForm.paramName" placeholder="请输入"></el-input>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span> </span>关联功能：</div>
        <el-select
          class="w60f"
          v-model="codeList"
          filterable
          multiple
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in codeOption"
            :key="index"
            :label="item.functionName"
            :value="item.functionCode"
          ></el-option>
        </el-select>
        <!-- <el-input class="w60f" v-model="ruleForm.paramName"></el-input> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogFormVisible: false,
      ruleForm: {
        guid: null,
        tenantGuid: '',
        bizType: '调研对象',
        tenantName:'',
        paramName: '',
        paramValue:'',
        paramValue1:''
      },
      textTitle: '',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        bizType: '调研对象',
        // tenantName: '',
        paramName: '',
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      valueList:[],
      codeOption:[],
      codeList:[]
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getCode()
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        bizType: '调研对象',
        // tenantName: '',
        paramName: '',
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.loading = true;
      self.tableData = [];
      self.page.tenantGuid = '';//修改为平台级
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getCode(){
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: 200,
      }
      self.api.postJson(`/${serverConfig.msConfigureService}/function/list`, page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.codeOption = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    add(flg, row) {
      let self = this;
      // ruleForm: {
      //   guid: null,
      //   tenantGuid: '',
      //   bizType: '调研对象',
      //   tenantName:'',
      //   paramName: '',
      //   paramValue:'',
      //   paramValue1:''
      // }
      console.log('rr',row);
      
      if (flg == 1) {
        self.textTitle = '新增客户类型';
        self.ruleForm.guid = null;
        self.ruleForm.tenantGuid = '';
        self.ruleForm.bizType = '调研对象';
        self.ruleForm.tenantName = '';
        self.ruleForm.paramName = '';
        self.ruleForm.paramValue = '';
        self.ruleForm.paramValue1 = '';
        self.codeList=[]
      } else {
        self.textTitle = '编辑客户类型';
        self.ruleForm.guid = row.guid;
        self.ruleForm.tenantGuid = row.tenantGuid;
        self.ruleForm.bizType = row.bizType;
        self.ruleForm.tenantName = row.tenantName;
        self.ruleForm.paramName = row.paramName;
        self.ruleForm.paramValue = row.paramValue;
        self.ruleForm.paramValue1 = row.paramValue1;
        if(row.paramValue1){
          self.codeList = row.paramValue1.split(',');
        }else{
          self.codeList = []
        }
      }
      self.dialogFormVisible = true;
    },
    submitForm() {
      let self = this;
      if(!self.ruleForm.paramValue){
        self.$message.error('客户类型编号不能为空！');
        return
      }
      if(!self.ruleForm.paramName){
        self.$message.error('客户类型名称不能为空！');
        return
      }
      // if(!self.codeList.length){
      //   self.$message.error('请选择关联功能！');
      //   return
      // }
      self.ruleForm.tenantGuid = localStorage.guid;
      self.ruleForm.tenantName = JSON.parse(localStorage.userInfo).tenantName;
      if(self.codeList.length>0){
        this.ruleForm.paramValue1 = self.codeList.join(',');
      }else{
        this.ruleForm.paramValue1 = '';
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, this.ruleForm).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogFormVisible = false;
          if(self.ruleForm.guid){
            self.$message.success('修改成功');
          }else{
            self.$message.success('添加成功');
          }
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
        self.valueList.push(item.paramValue)
      });
      console.log(self.valueList)
    },
    
    deleteData(flg, row){
      let self = this;
      if(flg !== 1){
        self.valueList = [row.paramValue];
      }
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/dict/check/customer-type/used`, self.valueList)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if(res.data.data == false){
              self.getDeleteData(flg, row.guid);
            }else{
              self.$message.error('该类型已被使用，无法删除');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('删除后不可恢复, 确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/delete-list`, self.multipleSelection)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.valueList = [];
                self.$message.success('删除成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
